import { render, staticRenderFns } from "./SpeakerMenu.vue?vue&type=template&id=8c6cbd5c&scoped=true"
import script from "./SpeakerMenu.vue?vue&type=script&lang=js"
export * from "./SpeakerMenu.vue?vue&type=script&lang=js"
import style0 from "./SpeakerMenu.vue?vue&type=style&index=0&id=8c6cbd5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6cbd5c",
  null
  
)

export default component.exports